import { getElem, logEvent, pause } from "../utils";
import HTML_SaveShare from "./HTML_SaveShare";

class HTML_GameOver {
    private lastRecordedBlob: Blob | null = null;
    private html_SaveShare: HTML_SaveShare;
    private gameReset: (() => void) | null = null;
    private wonGame = false;
    private html = {
        gameover: getElem("gameover"),
        container: getElem("gameover-container"),
        headImg: {
            logo: getElem("gameover-logo"),
            loss: {
                elem: getElem("gameover-loss"),
                img: getElem("gameover-loss-img"),
                p: getElem("gameover-loss-p"),
            },
        },
        text: {
            elem: getElem("gameover-text"),
            score: getElem("gameover-score"),
            time: getElem("gameover-time"),
        },
        buttons: getElem("gameover-bottomButtons"),
        replayBtn: getElem("gameover-replay"),
        shareBtn: getElem("gameover-share"),

        scoreTxt: getElem("gameover-score"),
        timeTxt: getElem("gameover-time"),
    };

    constructor() {
        this.html.gameover.style.display = "none";

        this.html.headImg.loss.img.style.scale = '2';
        this.html.headImg.loss.img.style.opacity = '0';

        this.html.headImg.loss.p.style.scale = '2';
        this.html.headImg.loss.p.style.opacity = '0';

        this.html.buttons.style.bottom = '-10%';
        
        this.html_SaveShare = new HTML_SaveShare();
        this.html.replayBtn.addEventListener("pointerup", async () => {
            if(!this.gameReset) {
                throw new Error("No game reset function, major logic error in Game Over script");
            }
            logEvent("replay_button_click")
            await this.hide();
            this.gameReset();
        })
        
        this.html.shareBtn.addEventListener("pointerup", async () => {
            logEvent("share_button_click")
            await this.hide();
            this.showSaveShare();
        })
    }
    
    public async activate(wonGame: boolean, score: {score: number, time: string}, blob: Blob, gameReset: () => void) {
        this.html.scoreTxt.innerHTML = score.score.toString();
        this.html.timeTxt.innerHTML = score.time;
        this.lastRecordedBlob = blob || this.lastRecordedBlob;
        this.gameReset = gameReset;
        this.wonGame = wonGame;
        this.view();
    }

    private showSaveShare() {
        if (!this.lastRecordedBlob) {
            console.error('No video blob available to download');
            return;
        }
        
        this.html_SaveShare.activate(this.lastRecordedBlob, () => {
            // Show UI again
            this.view();
        })
    }

    private view() {
        if(this.wonGame) {
            this.viewGameEnd();
        } else {
            this.viewGameOver();
        }
    }
    
    // Messy HTML animations
    private async viewGameEnd() {
        this.genericBits(true);
        this.html.headImg.logo.style.display = "flex";
        this.html.gameover.style.display = "flex";
        await pause(200);
        this.html.headImg.logo.style.top = '0px';

    }
    
    private async viewGameOver() {
        this.genericBits(true);
        this.html.headImg.loss.elem.style.display = "flex";
        await pause(200);
        this.html.headImg.loss.img.style.scale = '';
        this.html.headImg.loss.img.style.opacity = '';

        await pause (200);
        this.html.headImg.loss.p.style.scale = '';
        this.html.headImg.loss.p.style.opacity = '';
    }
    
    private async genericBits(state: boolean) {
        if(state) {
            this.html.gameover.style.display = "flex";
            this.html.container.style.opacity = '1';
            await pause (200);
            this.html.gameover.style.opacity = "1";
            this.html.text.elem.style.opacity = '1';
            this.html.buttons.style.bottom = '';
            await pause (200);
            this.html.text.score.style.right = '0px';
            await pause (200);
            this.html.text.time.style.left = '0px';
        } else {
            this.html.gameover.style.opacity = "0";
            this.html.container.style.opacity = '0';
            // Text part
            this.html.text.elem.style.opacity = '0';
            this.html.text.score.style.right = '-100%';
            this.html.text.time.style.left = '-100%';
            this.html.buttons.style.bottom = '-10%';
            await pause(500);
            this.html.gameover.style.display = "none";
        }
    }
    
    private async hide() {
        this.genericBits(false);
        // Top stuff
        this.html.headImg.logo.style.top = '-100%';
        this.html.headImg.loss.img.style.opacity = '0';
        this.html.headImg.loss.p.style.opacity = '0';
        await pause(500);
        this.html.headImg.logo.style.display = 'none';
        this.html.headImg.loss.elem.style.display = "none";
        
        await pause(200);
        this.html.headImg.loss.img.style.scale = '2';
        this.html.headImg.loss.p.style.scale = '2';
    }


}

export default HTML_GameOver;